export interface Name {
  first?: string;
  firstName?: string;
  last?: string;
  lastName?: string;
}

export function getFullName(name: Name): string {
  const first = name.first || name.firstName || "";
  const last = name.last || name.lastName || "";

  const fullName = `${first} ${last}`.trim();
  // Convert the name to title case. Split after joining the first and last because some people have multiple last names
  return fullName
    .split(" ")
    .map(n => n.trim())
    .map(n => (n ? n[0].toLocaleUpperCase() + n.substring(1).toLocaleLowerCase() : ""))
    .join(" ");
}

export function getInitials(name: Name): string {
  const getInitial = (n?: string) => {
    if (!n) return "";

    n = n.trim();
    return n.length > 0 ? n[0].toUpperCase() : "";
  };

  const first = name.first || name.firstName || "";
  const last = name.last || name.lastName || "";

  return getInitial(first) + getInitial(last);
}

export const sortByFullName = (a: Name, b: Name): number => {
  // Use toLowerCase so that sorting is case insensitive
  const aName = getFullName(a).toLowerCase();
  const bName = getFullName(b).toLowerCase();

  return aName > bName ? 1 : -1;
};

export const sortByInitials = (a: Name, b: Name): number =>
  // Don't need to worry about case sensitivity since initials are in upper case
  getInitials(a) > getInitials(b) ? 1 : -1;
